
















import Vue from 'vue'
import data from '../../banner.json'

type BannerData = {
  [index: string]: any;
  maintenance_from: string;
  maintenance_until: string;
  show_from: string;
  show_until: string;
}

const bannerData: BannerData = data

export default Vue.extend({
  name: 'MaintenanceBanner',
  data () {
    return {
      show: false,
      dayFrom: '',
      dayUntil: '',
      maintenancePeriod: ''
    }
  },
  mounted () {
    const { $moment } = this
    const date = new Date()

    const dateFrom = new Date(bannerData.show_from)
    const dateUntil = new Date(bannerData.show_until)

    const afterShowFrom = date > dateFrom
    const beforeShowUntil = date < dateUntil

    const maintenanceFrom = new Date(bannerData.maintenance_from)
    const maintenanceUntil = new Date(bannerData.maintenance_until)

    const dayFrom = $moment(maintenanceFrom, 'YYYY-MM-DD HH:mm:ss').format('dddd')
    const dayUntil = $moment(maintenanceUntil, 'YYYY-MM-DD HH:mm:ss').format('dddd')

    const fullFrom = this.dateTimeToLocal(bannerData.maintenance_from)
    const fullUntil = this.dateTimeToLocal(bannerData.maintenance_until)

    this.maintenancePeriod = `${dayFrom} ${fullFrom.slice(0, 6) + fullFrom.slice(8)} ${this.t({ s: 'until', component: 'Navigation' })} ${dayUntil} ${fullUntil.slice(0, 6) + fullUntil.slice(8)}`
    this.show = afterShowFrom && beforeShowUntil
  }
})
